import React from "react";
import FaqMenu from "./FaqMenu";
import { ThemeSelectMenu } from "./ThemeSelectMenu";
import { ButtonPrimary } from "components/Atoms/Button";
import { routes } from "utilities/routing/generatedRoutes";
import { SystemOneLogoSideNav } from "components/SidebarNavigation/SystemOneLogoSideNav";

const TopBarAnonymous = () => {
  return <>
    <div className="top-bar-wrapper">
      <SystemOneLogoSideNav collapsed={false} onOpen={() => { }} />
      <span className="top-bar-middle" />
      <FaqMenu />
      <ThemeSelectMenu />
      <ButtonPrimary label={RESX.GeneralLabels.SignIn} href={routes.account_SignIn().absolute} />
    </div>
  </>;
};

export default TopBarAnonymous;